import { Component, HostListener, OnInit } from '@angular/core';
import { SharedService } from './shared/shared.service';
import { AuthService } from './services/auth.service';

@Component({
    selector: 'pq-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'PivotQuote2UI';

  constructor(
    private sharedService: SharedService,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {}

  @HostListener('window:keydown')
  @HostListener('window:mousedown')
  async checkUserActivity() {
    const isActive = await this.authService.isAuthenticated();
    if (isActive) {
      clearTimeout(this.authService.timeoutId);
      this.authService.checkUserIdleTimeout();
    }
  }
}
